import { Field } from "formik";

import { AutocompleteWithInfiniteScroll } from "components/form/elements";

import {
  DEFAULT_ITEMS_PER_PAGE,
  DEFAULT_LABEL,
  DEFUALT_INPUT_PLACEHOLDER,
} from "./constants";
import { useApplicationAutocomplete } from "./useApplicationAutocomplete";

interface Props {
  inputPlaceholder?: string;
  label?: string;
  required?: boolean;
  excludeIDs?: string[];
  isReadonly: boolean;
  loading: boolean;
  name: string;
  onChange?: (value: any) => void;
  validate?: (value: any) => any;
  limit: number;
}

export function TiVoApplicationField({
  inputPlaceholder = DEFUALT_INPUT_PLACEHOLDER,
  label = DEFAULT_LABEL,
  required = true,
  excludeIDs = [],
  isReadonly = false,
  loading = false,
  name,
  onChange = () => {},
  validate = () => {},
  limit = DEFAULT_ITEMS_PER_PAGE,
}: Props) {
  const { fetchData, fetchInitialItem, mapData, mapInitialItem } =
    useApplicationAutocomplete({ excludeIDs, limit });

  return (
    <Field name={name} validate={validate}>
      {({ field, meta, form: { getFieldHelpers } }: any) => {
        const { setValue } = getFieldHelpers(name);
        return (
          <AutocompleteWithInfiniteScroll
            inputPlaceholder={inputPlaceholder}
            label={label}
            required={required}
            {...field}
            {...meta}
            onChange={(value: string) => {
              setValue(value);
              onChange(value);
            }}
            fetchData={fetchData}
            mapData={mapData}
            fetchInitialItem={fetchInitialItem}
            mapInitialItem={mapInitialItem}
            itemsPerPage={limit}
            disabled={loading || isReadonly}
          />
        );
      }}
    </Field>
  );
}
